import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/workspace/src/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Contact"] */ "/workspace/src/components/sections/contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Cta"] */ "/workspace/src/components/sections/cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Faq"] */ "/workspace/src/components/sections/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Features"] */ "/workspace/src/components/sections/features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/workspace/src/components/sections/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorks"] */ "/workspace/src/components/sections/how-it-works.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LiveColors"] */ "/workspace/src/components/sections/live-colors.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Testimonials"] */ "/workspace/src/components/sections/testimonials.tsx");
